import React, { memo } from 'react';
import cn from 'classnames';
import styles from './index.module.less';
import { HeaderLogo, IHeaderLogoProps } from '@pro/common/HeaderLogo';
import HeaderSearch from '@app/common/PageHeader/HeaderSearch';
import HeaderSupport from '@app/common/PageHeader/HeaderSupport';
import HeaderAccount from '@app/common/PageHeader/HeaderAccount';
import HeaderCart from '@app/common/PageHeader/HeaderCart';
import HeaderCountry from '@app/common/PageHeader/HeaderCountry';
import HeaderNav from '@app/common/PageHeader/HeaderNav';

type HeaderBarProps = {
    disableMiniCart?: boolean;
    onlyShowLogo?: boolean;
    logoType?: IHeaderLogoProps['type'];
};

export const HeaderBar: React.FC<HeaderBarProps> = memo(props => {
    const {
        disableMiniCart = false,
        logoType,
    } = props;

    return (
        <div className={cn('header-bar', styles['header-bar'])}>
            <div id="js-header-bar-scope" className="wrapper-large flex flex-middle flex-wrap relative">
                <div className={cn('flex flex-middle', styles.left)}>
                    <HeaderLogo type={logoType}/>
                    <HeaderNav/>
                </div>

                <HeaderSearch className={cn(styles.center, 'text-center')}/>

                <div className={cn(styles.right, 'text-right')}>
                    <HeaderSupport/>
                    <HeaderCountry/>
                    <HeaderAccount/>
                    <HeaderCart disableMiniCart={disableMiniCart}/>
                </div>
            </div>
        </div>
    )
});